export default __webpack_public_path__ + "static/media/more-black.8ad1c4ab.svg";